'use client';
import { useState, useEffect } from 'react';
import { SitePhrase, getSitePhrases, getPhrase, getMaidBgImage, MAID_BG_KEY } from '@/lib/siteContent';

export function useSiteContent() {
  const [phrases, setPhrases] = useState<SitePhrase[]>([]);
  const [maidBg, setMaidBg] = useState<string>('/assets/images/maid_background.png');

  useEffect(() => {
    setPhrases(getSitePhrases());
    setMaidBg(getMaidBgImage());

    const handleStorage = (e: StorageEvent) => {
      if (e.key === 'cvmaids_site_phrases') {
        setPhrases(getSitePhrases());
      }
      if (e.key === MAID_BG_KEY) {
        setMaidBg(getMaidBgImage());
      }
    };

    // Also listen for custom events (same-tab updates)
    const handleCustom = () => {
      setPhrases(getSitePhrases());
      setMaidBg(getMaidBgImage());
    };

    window.addEventListener('storage', handleStorage);
    window.addEventListener('cvmaids_content_updated', handleCustom);
    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('cvmaids_content_updated', handleCustom);
    };
  }, []);

  const p = (key: string) => getPhrase(key, phrases);

  return { phrases, maidBg, p };
}
